export default function mutate(source, mutatorFn) {
  const copy = { ...source };

  mutatorFn(copy);

  return copy;
}
